import { bsc } from "wagmi/chains";


export const contract = {
  97: {
    STAKE_ADDRESS: "0xe92b26b989c471caef8bb201140b346ecf32aad4",
    MULTICALL_ADDRESS: "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18",
    TOKEN_ADDRESS: "0x19D2f834eec88899727662e75CA16ABefB5E3a06",
    USDT_ADDRESS : "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
    USDC_ADDRESS : "0x64544969ed7EBf5f083679233325356EbE738930"
  },
  56: {
    STAKE_ADDRESS: "0xd5a17292dc9b29ff6fb9ace4d1283a5de6bb87aa",
    MULTICALL_ADDRESS: "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116",
    TOKEN_ADDRESS: "0x1C472EfF1B5970f995A10Af5Be2d66242654282d",
    USDT_ADDRESS : "0x55d398326f99059ff775485246999027b3197955",
    USDC_ADDRESS : "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d"
  }
}

export const DEFAULT_CHAIN = 56;
export const DEFAULT_RPC = "https://bsc-dataseed1.binance.org/"
// export const DEFAULT_RPC = "https://data-seed-prebsc-2-s1.binance.org:8545/"
export const PROJECT_ID = "27b9720018bf7f8740936e6a6eb28604";
export const DECIMALS = 18;
export const SYMBOL = 'PST';
export const EXPLOER = 'https://bscscan.com/';
export const chains = [bsc]






